<div class="mb-0">
  <label [for]="id" class="mb-0">ADDITIONAL DETAIL</label>
  @if (!show) {
    <fa-icon [icon]="['fas', 'plus-square']" (click)="onPlusClick()" />
  }
  @if (show) {
    <fa-icon [icon]="['fas', 'minus-square']" (click)="onMinusClick()" />
  }
  @if (show) {
    <textarea
      [id]="id"
      [name]="id"
      class="form-control py-0 px-1 phi"
      [class]="{ 'is-invalid': required && isEmpty }"
      [disabled]="frozen"
      (change)="onAdditionalTextChange()"
      [(ngModel)]="value"
      [rows]="rows"
      [required]="required"
      >
    </textarea>
  }
</div>
